module.exports = __webpack_public_path__ + "media/application/images/icons/confidence-level-4-7969799ca315632c6b42171c38819255.svg";